import { useMemo } from "react";
import { useGrpcClient, usePropertyGrpcCall } from "../../../../lib/grpc";
import { PropertyConfigurationAPIPromiseClient } from "../../../../gen/witbooking/backoffice/propertyconfiguration/v1/propertyconfiguration_api_grpc_web_pb";
import { GetConfigurationByPropertyNameRequest } from "../../../../gen/witbooking/backoffice/propertyconfiguration/v1/propertyconfiguration_api_pb";

export function usePropertyConfigurationApi() {
  const grpcClient = useGrpcClient(PropertyConfigurationAPIPromiseClient);
  const getConfigurationByPropertyName = usePropertyGrpcCall(
    grpcClient,
    grpcClient.getConfigurationByPropertyName
  );

  return useMemo(
    () => ({
      isAccommodationModel: async () => {
        const request = new GetConfigurationByPropertyNameRequest();
        request.setPropertiesList(["occupationType"]);
        const response = await getConfigurationByPropertyName(request);
        return response.getConfigurationsMap().get("occupationType") === "PAX_TYPE";
      },
    }),
    [getConfigurationByPropertyName]
  );
}
